export default __webpack_public_path__ + "static/media/lock@2x.f9eaeb24.png";